const IS_FEATURE_ENABLED = 'featureToggles/isFeatureEnabled'

const _getters = {
  // AHA-47221: the ticked slides, and a per-slide test for the sidebar's tick boxes. The test
  // is a getter returning a function because each row asks about its own slide; a plain getter
  // would have to be recomputed per row anyway.
  pptSelectedSlideIds: (state) => state.selectedSlideIds,
  isPptSlideSelected: (state) => (slideId) => state.selectedSlideIds.includes(slideId),
  // AHA-48037: kill switch for the focus-driven add-in ownership re-assert. When the flag is on,
  // browser focus no longer moves slide ownership (no peer stand-down broadcast, no re-assert),
  // restoring the pre-AHA-48037 behaviour. Off by default — an undefined/disabled flag reads false,
  // so the feature ships live and the flag only ever removes it.
  isPptOffActiveOnFocusEnabled: (_state, _moduleGetters, _rootState, rootGetters) => Boolean(
    rootGetters[IS_FEATURE_ENABLED]('AHA-48037-ppt-off-active-onfocus'),
  ),
  // AHA-42923: gates the present-mode canvas refit — the fullscreen/view/ResizeObserver triggers
  // that refit the canvas when the HOST resizes the webview without firing a DOM 'resize'.
  // Normal polarity, unlike the kill switch above: OFF is the pre-AHA-42923 behaviour (the canvas
  // keeps the edit-pane scale in the slideshow) and turning the flag ON adds the triggers, so an
  // undefined/disabled flag ships exactly what staging does today.
  isPptFixResizeEnabled: (_state, _moduleGetters, _rootState, rootGetters) => Boolean(
    rootGetters[IS_FEATURE_ENABLED]('AHA-42923-ppt-fix-resize'),
  ),
  // Slides added from the sidebar carry their sidebar thumbnail as PowerPoint's
  // add-in snapshot. OFF keeps PowerPoint's own capture.
  isPptSlideSnapshotEnabled: (_state, _moduleGetters, _rootState, rootGetters) => Boolean(
    rootGetters[IS_FEATURE_ENABLED]('AHA-48164-ppt-addin-slide-snapshot'),
  ),
  // OFF keeps the TinyMCE title editor in a presenting add-in frame.
  isPptStaticTitlePresentingEnabled: (_state, _moduleGetters, _rootState, rootGetters) => Boolean(
    rootGetters[IS_FEATURE_ENABLED]('AHA-48723-ppt-static-title-presenting'),
  ),
  // OFF runs the editor-only work at mount in a presenting add-in frame.
  isPptPresentingDeferEditorEnabled: (_state, _moduleGetters, _rootState, rootGetters) => Boolean(
    rootGetters[IS_FEATURE_ENABLED]('AHA-48723-ppt-presenting-defer-editor'),
  ),
  // OFF leaves the switch of a bound ?presenting add-in frame to EditorHeader's own mount.
  isPptPresentBeforeFirstRenderEnabled: (_state, _moduleGetters, _rootState, rootGetters) => Boolean(
    rootGetters[IS_FEATURE_ENABLED]('AHA-48723-ppt-present-before-first-render'),
  ),
}

export default _getters
